/**
 * @module runtime
 * @description Auto-generated services, controllers, and routes for entities
 *
 * @dependencies
 * - NONE (fully isolated from db/, core/, engine/)
 *
 * @note This module is intentionally isolated to ensure services are portable
 *       and testable. All external dependencies are injected via ModuleContext.
 *
 * @usage
 * ```typescript
 * import { createEntityRuntime, createModuleRouters } from './runtime/index.js'
 *
 * // Create runtime for a single entity
 * const runtime = createEntityRuntime(ctx, postEntity)
 * app.use('/posts', runtime.router)
 *
 * // Create routers for all entities in a module
 * const router = createModuleRouters(ctx, module.definitions)
 * app.use('/api/cms', router)
 * ```
 */

// Types
export * from './types.js'

// Entity Factory
export {
  createEntityService,
  createEntityServiceAsync,
  createModuleServices,
  getServiceKey
} from './entity-factory.js'

// Services
export { BaseEntityService } from '@kernel/runtime/services/base.service.js'
export { CollectionService } from '@kernel/runtime/services/collection.service.js'
export { SingleService } from '@kernel/runtime/services/single.service.js'
/** @deprecated Use CollectionService instead. Reference entities are now collections with seed. */
export { CollectionService as ReferenceService } from '@kernel/runtime/services/collection.service.js'
/** @deprecated Use CollectionService with immutable: true instead */
export { CollectionService as EventService } from '@kernel/runtime/services/collection.service.js'
/** @deprecated Use SingleService with scopeField instead */
export { SingleService as ConfigService } from '@kernel/runtime/services/single.service.js'
/** @deprecated Use CollectionService with retention instead */
export { CollectionService as TempService } from '@kernel/runtime/services/collection.service.js'
export { ViewService } from '@kernel/runtime/services/view.service.js'
export { ExternalService } from '@kernel/runtime/services/external.service.js'
/** @deprecated Use ComputedService with sources instead */
export { ComputedService as VirtualService } from '@kernel/runtime/services/computed.service.js'
export { ComputedService } from '@kernel/runtime/services/computed.service.js'
// TreeService and DagService are exported separately to avoid circular dependency issues
// Import directly from ./services/tree.service.js or ./services/dag.service.js

// Validation
export { buildCreateSchema, buildUpdateSchema, getSchemas } from '@kernel/runtime/validation/index.js'

// Helpers
export * from '@kernel/runtime/helpers/index.js'
